<div class="flex h-full flex-col">
  <div class="header relative p-3">
    <div class="title text-center text-lg">Happy Pay Topup</div>
    <button
      type="button"
      class="close absolute top-[50%] right-3 -translate-y-[50%]"
      (click)="ref.close()">
      <fa-icon [icon]="faTimes"></fa-icon>
    </button>
  </div>
  <form
    class="flex-1 space-y-3 overflow-y-auto p-3"
    [formGroup]="topUpForm"
    (ngSubmit)="onSubmit()">
    <div class="space-y-5" *ngIf="page == 1">
      <div class="form-control relative">
        <input
          #topUpAmount
          type="number"
          formControlName="amount"
          min="0"
          class="w-full rounded-md border border-primary-main p-2 placeholder:text-primary-main focus:border-primary-main focus:outline-none focus:ring-1 focus:ring-primary-main"
          placeholder="Topup Amount"
          id="topUpAmount" />
        <label
          for="topUpAmount"
          *ngIf="topUpAmount.value"
          class="absolute left-2 -top-2 w-fit bg-white px-1 text-xs text-primary-md-dark opacity-100">
          {{ topUpAmount.placeholder }}
        </label>
      </div>
      <div class="form-control-dropdown relative">
        <!-- note: need to disable readonly if have another method -->
        <div
          class="relative w-full rounded-md bg-white text-primary-darkest outline-none">
          <p-dropdown
            class="w-full"
            styleClass="w-full border-primary-dark"
            [options]="methodDropdown"
            optionValue="value"
            formControlName="method"
            appendTo="body"
            optionLabel="label"
            [disabled]="true"
            [readonly]="true"></p-dropdown>
        </div>
        <label
          for="method"
          class="absolute left-2 -top-2 w-fit bg-white px-1 text-xs text-primary-md-dark opacity-100">
          Payment Method
        </label>
      </div>
    </div>
    <div class="space-y-5" *ngIf="page == 2">
      <div class="form-group relative">
        <input
          id="billing_name"
          type="text"
          #billingName
          placeholder="Nama"
          class="relative w-full rounded-md border border-primary-dark p-3 text-primary-darkest outline-none"
          formControlName="billing_name" />
        <label
          for="billing_name"
          *ngIf="billingName.value"
          class="absolute left-2 -top-2 bg-white px-1 text-xs text-primary-md-dark opacity-100"
          >{{ billingName.placeholder }}</label
        >
      </div>
      <div class="form-group relative">
        <input
          id="billing_email"
          type="text"
          #billingEmail
          placeholder="Email"
          class="relative w-full rounded-md border border-primary-dark p-3 text-primary-darkest outline-none"
          formControlName="billing_email" />
        <label
          for="billing_email"
          *ngIf="billingEmail.value"
          class="absolute left-2 -top-2 bg-white px-1 text-xs text-primary-md-dark opacity-100"
          >{{ billingEmail.placeholder }}</label
        >
      </div>
      <div class="form-group relative">
        <input
          id="billing_phone"
          type="text"
          #phoneNo
          placeholder="Account No"
          class="relative w-full rounded-md border border-primary-dark p-3 text-primary-darkest outline-none"
          formControlName="billing_phone" />
        <label
          for="billing_phone"
          *ngIf="phoneNo.value"
          class="absolute left-2 -top-2 bg-white px-1 text-xs text-primary-md-dark opacity-100"
          >{{ phoneNo.placeholder }}</label
        >
      </div>
    </div>
    <div class="space-y-5" *ngIf="page == 3">
      <div class="form-group relative">
        <input
          id="billing_address"
          type="text"
          #billingAddress
          placeholder="Address"
          class="relative w-full rounded-md border border-primary-dark p-3 text-primary-darkest outline-none"
          formControlName="billing_address" />
        <label
          for="billing_address"
          *ngIf="billingAddress.value"
          class="absolute left-2 -top-2 bg-white px-1 text-xs text-primary-md-dark opacity-100">
          {{ billingAddress.placeholder }}
        </label>
      </div>
      <div class="form-group relative">
        <input
          id="billing_country"
          type="text"
          #billingCountry
          placeholder="Negara"
          class="relative w-full rounded-md border border-primary-dark p-3 text-primary-darkest outline-none"
          formControlName="billing_country" />
        <label
          for="billing_country"
          *ngIf="billingCountry.value"
          class="absolute left-2 -top-2 bg-white px-1 text-xs text-primary-md-dark opacity-100">
          {{ billingCountry.placeholder }}
        </label>
      </div>
      <div class="form-group relative">
        <input
          id="billing_state"
          type="text"
          #billingState
          placeholder="Provinsi"
          class="relative w-full rounded-md border border-primary-dark p-3 text-primary-darkest outline-none"
          formControlName="billing_state" />
        <label
          for="billing_state"
          *ngIf="billingState.value"
          class="absolute left-2 -top-2 bg-white px-1 text-xs text-primary-md-dark opacity-100">
          {{ billingState.placeholder }}
        </label>
      </div>
      <div class="form-group relative">
        <input
          id="billing_city"
          type="text"
          #billingCity
          placeholder="Kota"
          class="relative w-full rounded-md border border-primary-dark p-3 text-primary-darkest outline-none"
          formControlName="billing_city" />
        <label
          for="billing_city"
          *ngIf="billingCity.value"
          class="absolute left-2 -top-2 bg-white px-1 text-xs text-primary-md-dark opacity-100">
          {{ billingCity.placeholder }}
        </label>
      </div>
      <div class="form-group relative">
        <input
          id="billing_postal_code"
          type="text"
          #billingPostalCode
          placeholder="Postal Code"
          class="relative w-full rounded-md border border-primary-dark p-3 text-primary-darkest outline-none"
          formControlName="billing_postal_code" />
        <label
          for="billing_postal_code"
          *ngIf="billingPostalCode.value"
          class="absolute left-2 -top-2 bg-white px-1 text-xs text-primary-md-dark opacity-100">
          {{ billingPostalCode.placeholder }}
        </label>
      </div>
    </div>
  </form>
  <div class="action-btn flex items-center justify-end gap-3 p-3">
    <button
      type="button"
      class="btn-p-darkest-l"
      (click)="dismissModal()"
      type="button">
      Cancel
    </button>
    <button
      type="submit"
      class="rounded-md bg-primary-darkest px-3 py-1 text-white duration-300 ease-in-out hover:-translate-y-1"
      [disabled]="loading"
      [ngClass]="{ 'opacity-50': loading }"
      (click)="onSubmit()">
      <span class="btn-label">{{ page != 3 ? 'Berikutnya' : 'Top Up' }}</span>
      <fa-icon
        class="load-icon"
        *ngIf="loading"
        [icon]="faSpinner"
        [spin]="true"></fa-icon>
    </button>
  </div>
</div>
